import axios from "axios";
import config from "@/router/globalConfig";

export default {
  //Post Services axois
  updateUserPassword(_data_) {
    return axios.post(
      config.WEB_API_PATH + "ChangePassword/ChangeUserPassword",
      _data_,
      {
        headers: {
          __RequestVerificationToken: config.AF_Token,
          Authorization: config.LOG_Token
        }
      }
    );
  },
  Logout(_data_) {
    return axios.post(config.WEB_API_PATH + "Login/Logout", "", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/servicesJS/ChangePassword.js